import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const SelfRegistration = React.lazy(() => import("./SelfRegistration"));

function SelfRegistrationPage(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "selfRegistration.pageTitle",
      defaultValue: "Smart Portal - Self Registration",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({
            key: "selfRegistration.loadingPage",
            defaultValue: "Loading CTM Self Registration",
          })}
        />
      }
    >
      <SelfRegistration {...props} />
    </Suspense>
  );
}

export default SelfRegistrationPage;
